import { apiFetch } from '../utils/api';
import type { ProductVariant } from './productVariants';

export interface ProductRelatedVariant {
  id: string;
  relatedVariant: ProductVariant;
  createdAt: string;
  updatedAt: string;
}

export const fetchProductRelatedVariants = (
  variantId: string,
): Promise<ProductRelatedVariant[]> =>
  apiFetch<ProductRelatedVariant[]>(`/product/variants/${variantId}/related-variants`);

export const addProductRelatedVariant = (
  variantId: string,
  relatedVariantId: string,
): Promise<ProductRelatedVariant> =>
  apiFetch<ProductRelatedVariant>(`/product/variants/${variantId}/related-variants`, {
    method: 'POST',
    body: JSON.stringify({ relatedVariantId }),
  });

export const removeProductRelatedVariant = (
  variantId: string,
  relationId: string,
): Promise<void> =>
  apiFetch<void>(`/product/variants/${variantId}/related-variants/${relationId}`, {
    method: 'DELETE',
  });

